module.exports = __webpack_public_path__ + "static/media/squash_530_gr.c2d3f192.jpg";